import React from "react";
import { IndividualWeekSettingsWrapper } from "../../../StyledComponents";
import Day, { IndividualDay } from "../../Day";

interface Props {
    weekDays: Omit<IndividualDay, "isRegular">[];
    week: number;
}

const IndividualWeekSettingsContent = ({ weekDays }: Props) => (
    <IndividualWeekSettingsWrapper>
        {weekDays.map((day, index) => (
            <Day
                key={day.name}
                day={{
                    isRegular: false,
                    ...day,
                }}
            />
        ))}
    </IndividualWeekSettingsWrapper>
);

export default IndividualWeekSettingsContent;
